"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_BROWSING_CONTEXT = void 0;
/**
 * Specifies where to display a linked URL. It is a name of, or keyword for, a browsing context: a tab, window, or <iframe>.
 */
var BrowsingContext;
(function (BrowsingContext) {
    /**
     * Load the URL into a new browsing context. This is usually a tab, but users can configure browsers to use new windows instead.
     */
    BrowsingContext["BLANK"] = "_blank";
    /**
     * Load the URL into the parent browsing context of the current one. If there is no parent, this behaves the same way as _self.
     */
    BrowsingContext["PARENT"] = "_parent";
    /**
     * Load the URL into the same browsing context as the current one. This is the default behavior.
     */
    BrowsingContext["SELF"] = "_self";
    /**
     * Load the URL into the top-level browsing context (that is, the "highest" browsing context that is an ancestor of the current
     * one, and has no parent). If there is no parent, this behaves the same way as _self.
     */
    BrowsingContext["TOP"] = "_top";
})(BrowsingContext || (BrowsingContext = {}));
exports.default = BrowsingContext;
exports.DEFAULT_BROWSING_CONTEXT = BrowsingContext.SELF;
